import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  nome: Yup.string().trim().required('Nome é obrigatório'),
  departamento: Yup.string(),
  // Celular é opcional. Se o usuário digitar algo, precisa ser um número válido
  // (10 ou 11 dígitos). Campo vazio = não exibir contato.
  celular: Yup.string().test('celular-valido', 'Celular inválido', val => {
    const digitos = (val || '').replace(/\D/g, '');
    if (digitos.length === 0) return true;
    return digitos.length === 10 || digitos.length === 11;
  }),
});
